import flixToken from '../assets/tokens/flix.svg';

export const tokensList = [{
    image: flixToken, // svg image
    denom: 'ibc/CEE970BB3D26F4B907097B6B660489F13F3B0DA765B83CC7D9A0BC0CE220FA6F',
    displayDenom: 'FLIX',
}];
